import React, { Component } from 'react';
import './QuoteDetailsModal.css';
import PropTypes from 'prop-types';
import FormModal from 'components/shared/modal/FormModal';
import SearchableDropDownPaginated from 'components/shared/dropdown/SearchableDropDownPaginated';
import ContractorsApi from 'services/api/contractors-api';
import DetailsInfoItem from 'components/shared/details/DetailsInfoItem';
import ImageUpload from 'components/shared/image-upload/ImageUpload';
import Number from 'components/shared/text/Number';
import Date from 'components/shared/text/Date';
import Input from 'components/shared/input/Input';
import Button from 'components/shared/button/Button';
import ConfirmationModal from 'components/shared/modal/ConfirmationModal';
import MessageModal from 'components/shared/modal/MessageModal';

import moment from 'moment';
import numeral from 'numeral';

class QuoteDetailsModal extends Component {
  constructor(props) {
    super(props);

    this.state = this.initializeState(props);
  }

  static propTypes = {
    quote: PropTypes.object.isRequired,
    show: PropTypes.bool,
    taskImages: PropTypes.array.isRequired,
    workOrder: PropTypes.object.isRequired,
    onNegotiate: PropTypes.func,
    onEdit: PropTypes.func,
    onClose: PropTypes.func.isRequired,
    onDelete: PropTypes.func,
  };

  static defaultProps = {
    show: false,
  };

  initializeState = (props) => {
    const { quote } = props;
    return {
      readOnly: true,
      negotiate: false,
      negotiateSuccess: false,
      estimate: quote.estimate || '',
      counter: quote.counter || '',
      value: quote.value || '',
      contractor: quote.contractor_id
        ? {
            value: quote.contractor_id,
            label: quote.contractor_name,
          }
        : null,
      showDeleteConfirmation: false,
    };
  };

  handleClose = (event) => {
    event.preventDefault();
    this.props.onClose();
  };

  handleCancel = () => {
    this.setState(this.initializeState(this.props));
  };

  handleNegotiate = () => {
    this.setState({ negotiate: true });
  };

  handleNegotiateSubmit = () => {
    this.setState({ negotiate: false });
    this.props.onNegotiate(this.state.counter, this.handleNegotiateCallback);
  };

  handleNegotiateCallback = (response) => {
    if (response.ok) {
      this.setState({ negotiateSuccess: true });
    }
  };

  handleNegotiateSuccessHide = () => {
    this.setState({ negotiateSuccess: false });
    this.props.onClose();
  };

  handleSave = () => {
    const { estimate, value, contractor } = this.state;
    const contractorId = contractor ? contractor.value : '';
    this.setState({
      readOnly: true,
    });
    this.props.onEdit(estimate, value, contractorId);
  };

  handleEdit = (event) => {
    this.setState({
      readOnly: false,
    });
  };

  handleDelete = (result) => {
    if (result) {
      this.props.onDelete && this.props.onDelete();
      this.props.onClose();
    }
    this.setState({
      showDeleteConfirmation: false,
    });
  };

  onQuoteDeleteClick = () => {
    this.setState({
      showDeleteConfirmation: true,
    });
  };

  handleEstimateChange = (value) => {
    this.setState({
      estimate: value,
    });
  };

  handleCounterChange = (value) => {
    this.setState({
      counter: value,
    });
  };

  handleValueChange = (value) => {
    this.setState({
      value: value,
    });
  };

  handleContractorSelect = (option) => {
    this.setState({
      contractor: option,
    });
  };

  static loadContractors(tradeId, input, page) {
    return ContractorsApi.searchContractors(
      input,
      [tradeId],
      [],
      null,
      page
    ).then((response) => {
      if (response.ok) {
        return {
          ok: true,
          options: response.contractors.map((element) => {
            return {
              value: element.id,
              label: element.name,
            };
          }),
        };
      } else {
        return {
          ok: false,
          errors: response.errors,
        };
      }
    });
  }

  render() {
    const {
      readOnly,
      negotiate,
      negotiateSuccess,
      estimate,
      counter,
      value,
    } = this.state;
    const readOnlyButtons = readOnly && !negotiate;

    let workOrderTitle = `WO #${this.props.workOrder.number}`;
    if (this.props.workOrder.name !== null) {
      workOrderTitle += `: ${this.props.workOrder.name}`;
    }
    return (
      <FormModal
        className="quote-details-modal"
        show={this.props.show}
        title={
          <span>
            <span className="title-task">
              Task # <Number value={this.props.quote.task.number} format="00" />
              : {this.props.quote.task.trade.label}
            </span>
            <span className="title-wo">({workOrderTitle})</span>
          </span>
        }
        onClose={this.handleClose}
      >
        <div className="task-wo-details-container">
          <div>
            {readOnly && (
              <div>
                <DetailsInfoItem
                  lines={[this.props.quote.contractor_name]}
                  title="CONTRACTOR"
                />
              </div>
            )}

            {!readOnly && (
              <div>
                <DetailsInfoItem lines={[]} title="CONTRACTOR" />
                <div className="drop-down-container">
                  <SearchableDropDownPaginated
                    clearable
                    loadOptions={(input, page) =>
                      QuoteDetailsModal.loadContractors(
                        this.props.quote.task.trade.id,
                        input,
                        page
                      )
                    }
                    value={this.state.contractor}
                    onChange={this.handleContractorSelect}
                    placeholder="Select Subcontractor"
                    autoload={true}
                  />
                </div>
              </div>
            )}
          </div>
          <div>
            <div>
              <DetailsInfoItem
                lines={[
                  this.props.workOrder.building.location.street_address_1,
                  this.props.workOrder.building.location.city +
                    ', ' +
                    this.props.workOrder.building.location.state +
                    ' ' +
                    this.props.workOrder.building.location.zip,
                  this.props.workOrder.building.name !== '' &&
                  this.props.workOrder.building.name !== null
                    ? this.props.workOrder.building.name
                    : '',
                ]}
                title="BUILDING"
              />
            </div>
            <div>
              <DetailsInfoItem
                lines={this.props.workOrder.working_hours}
                title="AVAILABLE WORKING HOURS"
              />
            </div>
          </div>
          <div>
            <DetailsInfoItem
              lines={[this.props.quote.task.description]}
              title="DESCRIPTION"
            />
          </div>
        </div>

        <div className="images-container">
          <ImageUpload images={this.props.taskImages} readOnly={true} />
        </div>

        <div className="quotes-details-container">
          {this.props.quote.start_date !== null && (
            <div className="quote start-date">
              <div>Start Date</div>
              <div>
                <Date value={this.props.quote.start_date} format="M/D/YYYY" />
              </div>
            </div>
          )}

          {this.props.quote.days_of_duration !== null && (
            <div className="quote">
              <div>Duration</div>
              <div>{`${numeral(this.props.quote.days_of_duration).format(
                '0.[0]'
              )} ${
                this.props.quote.days_of_duration > 1 ? 'days' : 'day'
              }`}</div>
            </div>
          )}

          {this.props.quote.material_lead_days !== null && (
            <div className="quote">
              <div>Material Lead Time</div>
              <div>{`${numeral(this.props.quote.material_lead_days).format(
                '0.[0]'
              )} ${
                this.props.quote.material_lead_days > 1 ? 'days' : 'day'
              }`}</div>
            </div>
          )}

          {this.props.quote.task.completion_date !== null && (
            <div className="quote">
              <div>Task Completion Date</div>
              <div>
                <Date
                  value={this.props.quote.task.completion_date}
                  format="M/D/YYYY"
                />
              </div>
            </div>
          )}

          {this.props.quote.end_date !== null &&
            this.props.quote.task.completion_date !== null && (
              <div className="quote">
                <div>Contractor Completion Date</div>
                <div>
                  {this.getJobCompletionDiff() !== 0
                    ? `${
                        this.getJobCompletionDiff() > 0 ? '+' : ''
                      }${this.getJobCompletionDiff()} days from task completion date`
                    : 'Same as task completion date'}
                </div>
              </div>
            )}

          {readOnly && this.props.quote.estimate !== null && (
            <div className="quote cost">
              <div>Cost</div>
              <div>
                <Number value={estimate} format="$ 0" />
              </div>
            </div>
          )}

          {!readOnly && (
            <div className="quote cost">
              <div>Cost</div>
              <div>
                <Input
                  id="quote-estimate"
                  onChange={this.handleEstimateChange}
                  value={estimate}
                  theme="normal"
                />
              </div>
            </div>
          )}

          {!negotiate && this.props.quote.counter && (
            <div className="quote cost">
              <div>Counter</div>
              <div>
                <Number value={counter} format="$ 0" />
              </div>
            </div>
          )}

          {negotiate && (
            <div className="quote cost">
              <div>Counter</div>
              <div>
                <Input
                  id="quote-counter"
                  onChange={this.handleCounterChange}
                  value={counter}
                  theme="normal"
                />
              </div>
            </div>
          )}

          {readOnly && this.props.quote.estimate !== null && (
            <div className="quote cost">
              <div>Value</div>
              <div>
                <Number value={value} format="$ 0" />
              </div>
            </div>
          )}

          {!readOnly && (
            <div className="quote cost">
              <div>Value</div>
              <div>
                <Input
                  id="quote-value"
                  onChange={this.handleValueChange}
                  value={value}
                  theme="normal"
                />
              </div>
            </div>
          )}

          {this.props.quote.estimate !== null && (
            <div className="quote cost">
              <div>Total</div>
              <div>
                {(this.props.quote.status === 'received' &&
                  this.props.quote.counter_status === 'negotiating') ||
                negotiate ? (
                  <Number
                    value={numeral(counter).value() + numeral(value).value()}
                    format="$ 0"
                  />
                ) : (
                  <Number
                    value={numeral(estimate).value() + numeral(value).value()}
                    format="$ 0"
                  />
                )}
              </div>
            </div>
          )}

          {this.props.quote.description !== null &&
            this.props.quote.description !== '' && (
              <div className="quote description">
                <div>Description</div>
                <div>{this.props.quote.description}</div>
              </div>
            )}

          <div className="quote status">
            <div>Status</div>
            <div>
              {this.props.quote.status.charAt(0).toUpperCase() +
                this.props.quote.status.slice(1)}
            </div>
          </div>

          {this.props.quote.denied_reason !== null &&
            this.props.quote.denied_reason !== '' && (
              <div className="quote denied-reason">
                <div>Denied Reason</div>
                <div>{this.props.quote.denied_reason}</div>
              </div>
            )}

          {this.props.quote.submitted_on !== null && (
            <div className="quote submitted-date">
              <div />
              <div>
                Quoted Submitted on{' '}
                <Date value={this.props.quote.submitted_on} format="M/D/YYYY" />
              </div>
            </div>
          )}
        </div>

        {this.props.onNegotiate && this.props.onEdit && this.props.onDelete && (
          <div className="button-container">
            {readOnlyButtons &&
              this.props.quote.status === 'received' &&
              this.props.quote.contractor_id && (
                <Button
                  className="button-gray"
                  label="Negotiate"
                  onClick={this.handleNegotiate}
                />
              )}
            {readOnlyButtons && (
              <Button
                className="button-orange"
                label="Edit"
                onClick={this.handleEdit}
              />
            )}
            {readOnlyButtons && this.props.quote.status === 'waiting' && (
              <React.Fragment>
                <Button
                  className="btn button button-white"
                  label="Delete"
                  onClick={this.onQuoteDeleteClick}
                />
                <ConfirmationModal
                  show={this.state.showDeleteConfirmation}
                  message="Are you sure you want to delete this quote?"
                  onHide={this.handleDelete}
                />
              </React.Fragment>
            )}

            {!readOnlyButtons && (
              <React.Fragment>
                <Button
                  className="btn button button-white"
                  label="Cancel"
                  onClick={this.handleCancel}
                />
                {negotiate ? (
                  <Button
                    disabled={!counter}
                    className="btn button button-orange"
                    label="Submit"
                    onClick={this.handleNegotiateSubmit}
                  />
                ) : (
                  <Button
                    className="btn button button-orange"
                    label="Save"
                    onClick={this.handleSave}
                  />
                )}
              </React.Fragment>
            )}
          </div>
        )}

        {negotiateSuccess && (
          <MessageModal
            show={this.state.negotiateSuccess}
            message="Thank you. The counter offer was submitted to the Subcontractor."
            onHide={this.handleNegotiateSuccessHide}
          />
        )}
      </FormModal>
    );
  }

  getJobCompletionDiff() {
    return moment(this.props.quote.end_date).diff(
      moment(this.props.quote.task.completion_date),
      'days'
    );
  }
}

export default QuoteDetailsModal;



// WEBPACK FOOTER //
// ./src/components/admin/quotes/QuoteDetailsModal.js